/**
 * Copyright (c) 2023, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { Container, Grid, Link, Typography } from "@mui/material";
import React from "react";
import RegionPicker from "../Components/RegionPicker";
import { useCloud } from "../Hooks/Cloud";
import { useHeader } from "../Hooks/Header";
import { useShowRegion } from "../Hooks/ShowRegion";

/**
 * Header component
 * Description: This component is used to display the header.
 */
function Header() {
  const { cloud } = useCloud();
  const { isVisible } = useHeader();
  const { isVisible: isRegionPickerVisible } = useShowRegion();

  if (!isVisible) {
    return null;
  }

  // const cloudImageSrc = window.ENV.logo.src[cloud];
  const logo = window.ENV[cloud].logo;

  return (
    <Container maxWidth="md" sx={ { my: 4 } }>
      <Container>
        <Grid container spacing={ 2 } justifyContent="center" alignItems="center">
          <Grid item xs={ 12 } sm={ 6 }>
            <Link href={ "/" }>
              { logo && logo.src ? (
                <img src={ logo.src } alt={ logo.alt } height={ logo.height } width={ logo.width } />
              ) : (
                <Typography variant="h4">{ logo.text }</Typography>
              ) }
            </Link>
          </Grid>
          <Grid item xs={ 12 } sm={ 6 } container justifyContent="flex-end">
            { isRegionPickerVisible && (
              <RegionPicker />
            ) }
          </Grid>
        </Grid>
      </Container>
    </Container>
  );
}

export default Header;
